<!--
 * @Description  : 描述：指标分析首页 --- 新（单项工程）
 * @Author       : 王帅
 * @Date         : 2024-08-26 09:17:41
 * @LastEditors  : 王帅
 * @LastEditTime : 2024-08-27 10:24:46
 * @FilePath     : \analysis_audit_admin\src\views\cost-analysis\analysis-target\target_index_new.vue
-->
<template>
	<w-split v-model="splitV">
		<left-structure slot="left" @rowClick="rowClick" hideBtn></left-structure>
		<template v-if="curLevelType === 1" v-loading="loading">
			<right-structure-unit
				slot="right"
				ref="rightUnit"
				show-checkbox
				:resData="unitResData"
				:pageLoading="loading"
				:temType="curRangeType"
				:curRowId="curRowId"
                hideBtn
			></right-structure-unit>
		</template>
		<template v-else v-loading="loading">
			<right-structure slot="right" :resData="resData" :curRangeType="curRangeType" :curRowId="curRowId" v-loading="loading" hideBtn></right-structure>
		</template>
	</w-split>
</template>

<script>
import leftStructure from '@/views/project-management/project-info/components/left_structure'
import rightStructure from '@/views/project-management/project-info/components/right_structure_custom'
import rightStructureUnit from '@/views/project-management/project-info/components/right_structure_unit'
import { structureFieldsAndValue, getNodeTrees, saveProTrees } from '@/api/modules/analysis'
import { getDictByParentValue } from '@/api/modules/dict.js'

export default {
	components: {
		leftStructure,
		rightStructure,
		rightStructureUnit
	},
	data() {
		return {
			splitV: 0.3,
			curLevelType: '', // 当前结构层级 (0, 1, 2)
			curRowId: '', // 当前row id
			curRangeType: '',
			curProjectType: '',	// 根节点
			resData: [],
			unitResData: {},
			loading: false
		}
	},
	methods: {
		// 左侧树点击事件
		rowClick(row) {
			this.loading = true

			// 赋值
			this.curLevelType = row.levelType
			this.curRowId = row.id
			this.resData = []

			switch (row.levelType) {
				// 点击根节点
				case 0:
					this.curRangeType = row.projectType
					this.curProjectType = row.projectType

					// 调用接口
					this.getDataByLevel1()
					break
				case 1:
					this.unitResData = {}
					this.curRangeType = row.levelTypeCode

					// 调用接口
					this.getDataByLevel2()
					break
				default:
					this.$message.warning('单位工程下 暂无数据！')
					this.loading = false
			}
		},

		// 获取码表数组
		async getDict(value) {
			let res = await getDictByParentValue({ value: value })

			return Promise.resolve(res)
		},

		// 点击根节点
		getDataByLevel1() {
			structureFieldsAndValue({
				rangeType: this.curRangeType,
				aid: this.curProjectId,
				contractTreeId: this.curRowId
			})
				.then((res) => {
					this.loading = false
					let length_list = []

					res.data.forEach((x) => {
						// 正常结构
						x.usualFieldList.map((y) => {
							// 系统码表
							if ((y && y.formType === '1005007') || (y && y.formType === '1005008') || (y && y.formType === '1005009')) {
								this.getDict(y.additional.dictionaryType).then((res) => {
									y.options = res.data
								})
							}
						})

						// 树结构
						x.specialBlockList.map((y) => {
							// 系统码表
							if ((y && y.formType === '1005007') || (y && y.formType === '1005008') || (y && y.formType === '1005009')) {
								this.getDict(y.additional.dictionaryType).then((res) => {
									y.options = res.data
								})
							}

							y.children.map((z) => {
								// 系统码表
								if ((z && z.formType === '1005007') || (y && y.formType === '1005008') || (y && y.formType === '1005009')) {
									this.getDict(y.additional.dictionaryType).then((res) => {
										z.options = res.data
									})
								}
							})
						})

						// 平级结构
						let _colspan = x.commonBlockList.filter((z) => z.rowIndex === 1).length
						x.commonBlockList.map((y) => {
							// 一行几个col
							y.parentCol = _colspan
							// 设置colSpan
							if (!length_list[y.rowIndex]) {
								length_list[y.rowIndex] = []
							}
							length_list[y.rowIndex].push(y)

							// 系统码表
							if ((y && y.formType === '1005007') || (y && y.formType === '1005008') || (y && y.formType === '1005009')) {
								this.getDict(y.additional.dictionaryType).then((res) => {
									y.options = res.data
								})
							}
						})

						// 数组去空
						length_list = length_list.filter((y) => y.length && y.length > 0)
						x.colSpan = length_list.length === 0 ? 1 : length_list[0].length
					})

					setTimeout(() => {
						this.resData = res.data
					}, 500)
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 点击单项工程
		getDataByLevel2() {
			let params = {
				nodeId: this.curRowId,
				temType: this.curProjectType,
				// temType: '1058001',
				projectId: this.curProjectId,
				menuType: 1	// 0 是项目结构  1是指标分析
			}
			getNodeTrees(params)
				.then((res) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
					this.unitResData = res.data
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 单项工程保存、提交
		doSave({ type, arr }) {
			// 树节点 isCheck 处理
			this.$utils.eachTree(arr, (x) => (x.isChecked = x.isChecked ? 1 : 0))

			// 递归往上改变父节点状态
			this.deepCheck(arr)

			let params = {
				nodeId: this.curRowId,
				projectId: this.curProjectId,
				isSubmit: type,
				treeArr: arr
			}
			// console.log('😍 ~:params', params)
			// this.$refs.rightUnit.handleCallBack('success', type)
			// return
			saveProTrees(params)
				.then((res) => {
					if (this.$refs.rightUnit) {
						let status = res.code === 0 ? 'success' : 'error'
						this.$refs.rightUnit.handleCallBack(status, type)
					}

					// 如果是提交, 回调接口更新
					if (type === 1) {
						this.getDataByLevel2()
					}
				})
				.catch((err) => {
					if (this.$refs.rightUnit) {
						this.$refs.rightUnit.handleCallBack('error')
					}
				})
		},

		// 递归
		deepCheck(arr) {
			this.$utils.map(arr, (x) => {
				if (x.children && x.children.length > 0 && x.isChecked !== 1) {
					this.deepCheck(x.children)

					let hasChecked = x.children.find((y) => y.isChecked == 1)
					x.isChecked = hasChecked ? 1 : 0
					return x
				}

				return x
			})
		}
	},
	computed: {
		curProjectId() {
			return this.$route.query.projectId || ''
		}
	}
}
</script>

<style scoped lang="less"></style>
